function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("rect", {
  width: 50,
  height: 80,
  fill: "currentColor",
  fillOpacity: 1
}), /*#__PURE__*/React.createElement("path", {
  fill: "#e6e9ed",
  d: "M14.0404597,38.2621528 L33.5964923,18.7071264 C34.5393276,17.7642912 36.0687934,17.7642912 37.0116287,18.7071264 L39.2927465,20.9882443 C40.2345755,21.9300733 40.2355818,23.4555143 39.2967715,24.3993557 L23.7978484,39.9697209 L39.2957652,55.5410924 C40.2355818,56.4849339 40.2335693,58.0103748 39.2917403,58.9522038 L37.0106224,61.2333217 C36.0677872,62.1761569 34.5383213,62.1761569 33.5954861,61.2333217 L14.0404597,41.6772891 C13.0976245,40.7344539 13.0976245,39.204988 14.0404597,38.2621528 Z",
  opacity: 1
}));

var SvgChevronLeft = function SvgChevronLeft(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 80,
    viewBox: "0 0 54 80",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgChevronLeft, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/chevron_left.b8579d21.svg";
export { ForwardRef as ReactComponent };